import { IUserContactPermissions, IUserPermissions } from "../../interface/IUserDetails";

interface IUserContactPermissionsResponse {
    enabled: boolean;
    name: string;
    permission: string;
}

interface IUserPermissionsResponse {
    name: string;
    permissionGroup: string;
    permissions: IUserContactPermissionsResponse[];
}

export interface IUserPermissionsGroupResponse {
    permissionGroupResponse: IUserPermissionsResponse[];
}

export const getResponseToState = (response: IUserPermissionsGroupResponse): IUserPermissions[] =>
    response.permissionGroupResponse.map((permission) => ({
        name: permission.name,
        permissionGroup: permission.permissionGroup,
        permissions: permission.permissions.map((contactPermission) => ({
            name: contactPermission.name,
            permission: contactPermission.permission,
            isEnabled: contactPermission.enabled,
        })),
    }));

export interface IUserContactPermissionsPayload {
    enabled: boolean;
    name: string;
    permission: string;
}

export interface IUserPermissionsPayload {
    permissionGroup: string;
    permissions: IUserContactPermissionsPayload[];
}

interface IUserPermissionGroupsPayload {
    allowThirdParty?: boolean;
    permissionGroups: IUserPermissionsPayload[];
}

export const getStateToPayload = (
    permissionGroup: string,
    userContactPermissions: IUserContactPermissions[]
): IUserPermissionGroupsPayload => ({
    permissionGroups: [
        {
            permissionGroup,
            permissions: userContactPermissions.map((userContactPermission) => ({
                name: userContactPermission.name,
                permission: userContactPermission.permission,
                enabled: userContactPermission.isEnabled,
            })),
        },
    ],
});

export const mapUserPermissionGroupsPayload = (prevIsThirdPartyAllowed: boolean): IUserPermissionGroupsPayload => ({
    allowThirdParty: !prevIsThirdPartyAllowed,
    permissionGroups: [], // TODO this is a workaround because we can't call route without this param - GCORE-656 => remove it when fixed
});
